import { render, staticRenderFns } from "./CustomerCoupon.vue?vue&type=template&id=857231ce&scoped=true"
import script from "./CustomerCoupon.vue?vue&type=script&lang=js"
export * from "./CustomerCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857231ce",
  null
  
)

export default component.exports